export default __webpack_public_path__ + "baeb197cfbfecc5678bb6e495b26bb4d.png";